import React from "react";
import { Styles } from "./styles";

let SecondaryButton = ({
  buttonText,
  buttonDisabled,
  buttonType,
  buttonClick,
}) => {
  return (
    <Styles>
      <button
        className={
          buttonDisabled
            ? "btn btn-secondary my-3 disabled"
            : "btn btn-secondary my-3"
        }
        disabled={buttonDisabled}
        id="main"
        type={buttonType}
        title={buttonText}
        onClick={buttonClick}
      >
        {buttonText}
      </button>
    </Styles>
  );
};

export default SecondaryButton;
